export default 'STATISTICS';
